import { render } from "./D3PieChart.vue?vue&type=template&id=fb3210f2&scoped=true"
import script from "./D3PieChart.vue?vue&type=script&lang=js"
export * from "./D3PieChart.vue?vue&type=script&lang=js"

import "./D3PieChart.vue?vue&type=style&index=0&id=fb3210f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3210f2"]])

export default __exports__